import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hotels: [],
  loading: false,
  error: null,
  filters: {
    priceRange: null,
    rating: null,
    amenities: [],
  },
};

export const hotelsSlice = createSlice({
  name: 'hotels',
  initialState,
  reducers: {
    setHotels: (state, action) => {
      state.hotels = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export const { setHotels, setLoading, setError, setFilters } = hotelsSlice.actions;

export default hotelsSlice.reducer;
